export const RECIPE_CATEGORIES = [
  { slug: 'fleisch', name: 'Fleisch', description: 'Feine Gerichte mit Hähnchen, Pute oder Rind – schonend zubereitet.' },
  { slug: 'fisch', name: 'Fisch', description: 'Leichte Rezepte mit Fisch, liebevoll komponiert für kleine Feinschmecker.' },
  { slug: 'gemuese', name: 'Gemüse', description: 'Bunte Gemüseküche mit hundegerechten Zutaten aus der Saison.' },
  { slug: 'snacks', name: 'Snacks', description: 'Kleine Leckerlis für zwischendurch – ehrlich und selbst gemacht.' },
  { slug: 'besondere-anlaesse', name: 'Besondere Anlässe', description: 'Festliche Menüs für Gotzstage, Geburtstage und gemütliche Sonntage.' },
  { slug: 'glutenfrei', name: 'Glutenfreie Rezepte', description: 'Alle Rezepte ohne Gluten – klar gekennzeichnet und transparent beschrieben.' },
];

export const recipes = [
  {
    slug: 'haehnchen-quinoa-bowl',
    name: 'Hähnchen-Quinoa-Bowl',
    seoTitle: 'Hähnchen-Quinoa-Bowl für Hunde | Rezept | Felix Genuss',
    metaDescription: 'Glutenfreie Hähnchen-Quinoa-Bowl für kleine Hunde: mit zartem Hähnchen, Quinoa und Gemüse. Schonend zubereitet in ca. 15 Minuten.',
    kurzbeschreibung: 'Zartes Hähnchen trifft auf fluffige Quinoa und feines Gemüse – eine glutenfreie Bowl für kleine Feinschmecker.',
    einleitung: 'Diese Bowl ist Felix\' erstes eigenes Rezept und unser liebevoller Auftakt: schonend gegartes Hähnchen, gut verdauliche Quinoa und fein gedünstetes Gemüse. Wie bei allen Felix-Genuss-Rezepten gilt: Die Mengen sind eine Orientierung für kleine Hunde und ersetzen keine individuelle Rationsberatung.',
    image: {
      src: '/assets/brand/rezept-quinoa-bowl-1024.webp',
      srcSet: '/assets/brand/rezept-quinoa-bowl-640.webp 640w, /assets/brand/rezept-quinoa-bowl-1024.webp 1024w, /assets/brand/rezept-quinoa-bowl-1400.webp 1400w',
      alt: 'Rezeptkarte Hähnchen-Quinoa-Bowl mit Felix, einem hellen Bolonka Zwetna',
      width: 1024,
      height: 1024,
    },
    kategorie: 'Fleisch',
    glutenfrei: true,
    schwierigkeit: 'Einfach',
    zubereitungszeit: '10 Minuten',
    gesamtzeit: '15 Minuten',
    portionen: '1–2 Mahlzeiten für einen kleinen Hund (ca. 5 kg)',
    groessenEmpfehlung: 'Kleine Hunde bis ca. 10 kg',
    zutaten: [
      { menge: '80 g', zutat: 'Hähnchenbrust (ohne Haut, ungewürzt)' },
      { menge: '40 g', zutat: 'Quinoa, gründlich gewaschen' },
      { menge: '30 g', zutat: 'Karotte, fein gewürfelt' },
      { menge: '30 g', zutat: 'Zucchini, fein gewürfelt' },
      { menge: '1 TL', zutat: 'Raps- oder Leinöl' },
      { menge: '150 ml', zutat: 'Wasser' },
    ],
    zubereitung: [
      'Quinoa gründlich unter fliessendem Wasser abspülen, dann mit 150 ml Wasser etwa 12 Minuten weich kochen.',
      'Hähnchenbrust in kleine, hundegerechte Stücke schneiden und in wenig Wasser vollständig durchgaren – ohne Salz und Gewürze.',
      'Karotte und Zucchini fein würfeln und die letzten 5 Minuten zur Quinoa geben, damit sie weich dünsten.',
      'Alles abkühlen lassen, Hähnchen unterheben und mit einem Teelöffel Öl vollenden.',
      'Lauwarm und auf Zimmertemperatur abgekühlt servieren. Felix empfiehlt: erst schnuppern, dann geniessen.',
    ],
    hinweise: [
      'Bitte immer vollständig durchgaren und niemals würzen – Salz, Zwiebeln und Knoblauch gehören nicht in den Hundenapf.',
      'Die passende Portionsgrösse hängt von Gewicht, Alter und Aktivität deines Hundes ab. Im Zweifel tierärztlich oder tierernährungsfachlich beraten lassen.',
      'Neue Zutaten schrittweise einführen und die Verträglichkeit beobachten.',
    ],
    allergene: ['Hähnchen (Geflügel)'],
    aufbewahrung: 'Abgedeckt im Kühlschrank bis zu 2 Tage haltbar. Vor dem Servieren auf Zimmertemperatur bringen – nicht aufwärmen und heiss servieren.',
    autor: 'Felix Genuss Redaktion',
    veroeffentlicht: '2026-07-01',
    geaendert: '2026-07-01',
  },
];
